'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMotorcycle = function MdMotorcycle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 28.4c2.8 0 5-2.3 5-5s-2.2-5-5-5-5 2.2-5 5 2.3 5 5 5z m-18.6-3.4h-4.6v-3.4h4.6c-0.7-1.9-2.5-3.2-4.6-3.2-2.8 0-5 2.2-5 5s2.2 5 5 5c2.1 0 3.9-1.4 4.6-3.4z m19.4-9.9c4.3 0.3 7.6 3.8 7.6 8.3 0 4.6-3.7 8.2-8.4 8.2s-8.2-3.6-8.2-8.2c0-1.1 0.1-2.1 0.4-3l-4.6 4.6h-2.7c-0.8 3.8-4.1 6.6-8.1 6.6-4.7 0-8.4-3.6-8.4-8.2s3.7-8.4 8.4-8.4h19.3l-3.4-3.4h-5.9v-3.2h7.3z' })
        )
    );
};

exports.default = MdMotorcycle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/motorcycle.js
// module id = 3318
// module chunks = 0